import * as React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';

export default function ChartTabLoader({ loading }) {
    if (!loading) {
        return null;
    }

    return (
        <Stack
            sx={{
                flex: 1,
                minHeight: 200,
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                py: 4,
            }}
        >
            <CircularProgress size={36} />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Loading...
            </Typography>
        </Stack>
    );
}
